module.exports = __webpack_public_path__ + "static/media/cover_scrub.46d7df9c.jpg";